import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A React Context that carries an external store from the component that writes it to the one
 * that reads it. The context value never changes, so a write re-renders only the value's readers.
 */
import { createContext, useContext, useState } from 'react';
import { createExternalStore, useExternalStoreValue } from './createExternalStore.js';
/**
 * A store context whose stores start at `initial`. Without a provider, a writer sets a stand-in
 * store that nothing reads.
 *
 * @canonical A React context that holds a store
 */
export function createStoreContext(initial, displayName) {
    const Context = createContext(createExternalStore(initial));
    Context.displayName = displayName;
    function Provider({ children }) {
        const [store] = useState(() => createExternalStore(initial));
        return _jsx(Context.Provider, { value: store, children: children });
    }
    const useStore = () => useContext(Context);
    return { Provider, useStore, useValue: () => useExternalStoreValue(useStore()) };
}
//# sourceMappingURL=createStoreContext.js.map